import { useState, useRef, useEffect } from "react"

export const SearchBarWithDebounce = ({ onSearchQueryChange, resetSignal }) => {
    const [searchFieldDisplay, setSearchFieldDisplay] = useState("")
    const changeSearchQueryTimeout = useRef()

    useEffect(() => {
        if (resetSignal === undefined) return
        if (changeSearchQueryTimeout.current) {
            clearTimeout(changeSearchQueryTimeout.current)
            changeSearchQueryTimeout.current = null
        }
        setSearchFieldDisplay("")
    }, [resetSignal])

    const changeSearchQuery = (query) => {
        setSearchFieldDisplay(query)
        if (changeSearchQueryTimeout.current) {
            clearTimeout(changeSearchQueryTimeout.current)
            changeSearchQueryTimeout.current = null
        }

        changeSearchQueryTimeout.current = setTimeout(() => {
            onSearchQueryChange(query)
        }, 1000)
    }

    const clearSearchField = () => {
        if (changeSearchQueryTimeout.current) {
            clearTimeout(changeSearchQueryTimeout.current)
            changeSearchQueryTimeout.current = null
        }
        setSearchFieldDisplay("")
        onSearchQueryChange("")
    }

    return (
        <div className="d-flex align-items-center border rounded bg-white">
            <input
                className="form-control form-control-sm border-0"
                value={ searchFieldDisplay }
                type="text"
                placeholder="search..."
                onChange={ (e) => changeSearchQuery(e.target.value) }
            />
            <button
                type="button"
                style={ { height: "34px", borderLeft: "1px solid #d8e2ef", borderRadius: 0 } }
                className="btn btn-sm py-0 px-3"
                onClick={ () => clearSearchField() }
            >
                <i className="fas fa-times"></i>
            </button>
        </div>
    )
}
